import {
  ButtonERP,
  DataTablePrimeReact,
  PaginationERP,
  TableERP,
} from "@finanedi.es/storybook"
import { FacturaRecurrenteReadingFiltersDtoProps } from "api/DTOs/FacturaRecurrenteReadingFiltersDto"
import {
  FacturaRecurrenteByFiltersQueryParamsProps,
  getFacturasRecurrentesByFilter,
} from "api/FacturaRecurrente.service"
import { SortingCriteria } from "api/interfaces/SortingCriteria"
import axios from "axios"
import NoResults from "common/components/NoResults"
import { STYLES } from "common/constants/styles"
import { PAGINATION_STYLES } from "constants/primereactStyles"
import { useFilterMenu } from "hooks/useFilterMenu"
import { Skeleton } from "primereact/skeleton"
import { useCallback, useRef, useState } from "react"
import { useTranslation } from "react-i18next"
import { useHistory } from "react-router-dom"
import * as ROUTES from "routes/RoutePaths"
import { FACTURAS_RECURRENTES_COLUMNS } from "./FacturasRecurrentesColumns"
import { FilterMenu as FilterMenuNew } from "./FilterMenu"
import "./style.scss"

const FacturasRecurrentes = () => {
  const { t } = useTranslation()
  const history = useHistory()
  const [sortingCriteria, setSortingCriteria] = useState<SortingCriteria>({
    sort: undefined,
    property: undefined,
  })
  const [pagination, setPagination] = useState({
    itemsPerPage: 100,
    skipCount: 0,
  })
  const [sortField, setSortField] = useState<string | undefined>(undefined)
  const [sortOrder, setSortOrder] = useState<1 | 0 | -1 | null | undefined>(0)

  const dtRef = useRef<DataTablePrimeReact<
    FacturaRecurrenteReadingFiltersDtoProps[]
  > | null>(null)
  const handleResetPagination = () => {
    dtRef.current && dtRef.current?.resetScroll()
    setPagination({
      itemsPerPage: pagination.itemsPerPage,
      skipCount: 0,
    })
  }
  const onSort = ({
    sortField,
    sortOrder,
  }: {
    sortField: string | undefined
    sortOrder: 1 | 0 | -1 | null | undefined
  }) => {
    setSortingCriteria({
      property: sortField ?? undefined,
      sort: sortOrder === 1 ? "ASC" : sortOrder === -1 ? "DESC" : undefined,
    })
    setSortField(sortField)
    setSortOrder(sortOrder)
    handleResetPagination()
  }

  const ventasCancelToken = useRef(axios.CancelToken.source())
  const fetchItemsVentas = useCallback(() => {
    return (queryState: FacturaRecurrenteByFiltersQueryParamsProps) => {
      ventasCancelToken.current?.cancel()
      ventasCancelToken.current = axios.CancelToken.source()
      return getFacturasRecurrentesByFilter(
        {
          ...queryState,
          MaxResultCount: queryState.MaxResultCount ?? pagination.itemsPerPage,
        },
        ventasCancelToken.current.token
      )
    }
  }, [pagination.itemsPerPage])
  const {
    items,
    isLoading,
    totalCount: totalcountnew,
    setServiceQuery,
  } = useFilterMenu({
    serviceCall: fetchItemsVentas,
  })
  const onRowClick = async ({
    data,
  }: {
    data: FacturaRecurrenteReadingFiltersDtoProps
  }) => {
    if (!data?.id) return

    history.push({
      pathname: `${ROUTES.FACTURAS_RECURRENTES}/${data.id}`,
    })
  }

  const redirectToCreate = () => history.push(ROUTES.CREAR_FACTURA_RECURRENTE)

  return (
    <>
      <div className='tw-flex tw-flex-col tw-w-full tw-shadow-3x2 tw-bg-simple-10 tw-py-3.5 tw-px-8 tw-m-px sm:tw-flex-row sm:tw-justify-between sm:tw-flex-wrap tw-gap-2'>
        <div className='tw-text-xl tw-font-normal tw-flex tw-items-center tw-text-nowrap'>
          {t("documentos.facturaRec.title")} (
          {isLoading ? (
            <Skeleton className='!tw-h-5 !tw-w-8 !tw-mx-1' />
          ) : (
            <span>{totalcountnew}</span>
          )}
          )
        </div>

        <span className={STYLES.tables.actions.container}>
          <FilterMenuNew
            serviceQuery={setServiceQuery}
            sortingCriteria={sortingCriteria}
            maxResultCount={pagination.itemsPerPage}
            skipCount={pagination.skipCount}
            resetPagination={handleResetPagination}
          />

          <ButtonERP
            customize={{
              size: "md",
              type: "secondary",
            }}
            onClick={redirectToCreate}
            label={`${t("documentos.facturaRec.addFactRec")}`}
          />
        </span>
      </div>
      <div className='tw-flex tw-flex-col tw-h-[calc(100%-70px)] tw-relative '>
        <div className='tw-h-[calc(100%-60px)] tw-min-h-0'>
          <TableERP
            refTable={dtRef}
            columns={FACTURAS_RECURRENTES_COLUMNS({ t })}
            className='tw-h-full !tw-z-0 tw-bg-white'
            columnResizeMode='expand'
            sortField={sortField}
            sortOrder={sortOrder}
            onSort={onSort}
            removableSort
            value={items}
            showGridlines
            lazy
            dataKey='id'
            scrollable
            size='small'
            onRowClick={onRowClick}
            loading={isLoading}
            emptyMessage={
              <NoResults
                iconType='recurrentes'
                title={t("documentos.facturaRec.new.title")}
                message={t("documentos.facturaRec.new.msg")}
                buttonLabel={t("documentos.facturaRec.new.newButton")}
                onClick={redirectToCreate}
              />
            }
          />
          <PaginationERP
            className={PAGINATION_STYLES}
            totalRecords={totalcountnew}
            first={pagination.skipCount}
            rows={pagination.itemsPerPage}
            resetScroll={() => {
              dtRef.current && dtRef.current?.resetScroll()
            }}
            setPagination={setPagination}
            optionDropdown={[10, 20, 50, 100]}
            texts={{
              textRowsPerPageDropdown: `${t("pagination.textRowsPag")}`,
              textCurrentPageReport: `${t("pagination.from")}`,
            }}
          />
        </div>
      </div>
    </>
  )
}

export default FacturasRecurrentes
